export default __webpack_public_path__ + "static/media/Hemmers_Logo_White.3a993adf.svg";